import DownloadProgressDrawer from '../DownloadProgressDrawer';
import UploadProgressDrawer from '../UploadProgressDrawer';
import UserImportProgressDrawer from '../UserImportProgressDrawer';

const TransferProgressDrawers = () => {
  return (
    // dashboard-no-print: fixed right-4 sits past the 1060px print canvas and inflates page width.
    <div className="dashboard-no-print fixed right-4 bottom-0 z-50">
      <div className="flex flex-col gap-2">
        <UserImportProgressDrawer />
        <DownloadProgressDrawer />
        <UploadProgressDrawer />
      </div>
    </div>
  );
};
export default TransferProgressDrawers;
